import { render, staticRenderFns } from "./SubscriptionBuilder.vue?vue&type=template&id=48b46fb6&scoped=true&"
import script from "./SubscriptionBuilder.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBuilder.vue?vue&type=style&index=0&id=48b46fb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b46fb6",
  null
  
)

export default component.exports